import lrTenantId from './_src/lrTenantId.vue'
lrTenantId.install = function(Vue) {
  Vue.component(lrTenantId.name, lrTenantId)
}

export default lrTenantId